import { useTranslation } from 'react-i18next'
import { Input } from '@/components/shadcn/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { HelpText } from '@/components/common/help/HelpText'
import { helpKey } from '@/lib/action-modules/help'
import { ScheduleDaysDefinitionEditor, type ScheduleDaysDefinitionProps } from './ScheduleDaysDefinitionEditor'
import { ScheduleWeekMode, type ScheduleWeek } from '@/lib/action-modules/registry/scheduling/types'

export interface ScheduleWeeksDefinitionEditorProps extends ScheduleDaysDefinitionProps {
  weekModel: ScheduleWeek
  onUpdateWeekModel: (value: ScheduleWeek) => void
}

export function ScheduleWeeksDefinitionEditor(props: ScheduleWeeksDefinitionEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const sd = (key: string) => t(`schedulingStrategy.scheduleDefinition.${key}`)
  const mode = (key: string) => sd(`weeks.scheduleMode.${key}`)
  return (
    <div className="flex flex-col gap-2 pt-4">
      <h4 className="text-sm font-semibold">{sd('weeks.title')}</h4>
      <HelpText helpKey={helpKey('schedulingWeeks')} />
      <div className="flex flex-wrap items-end gap-3 pt-1">
        <div className="flex min-w-60 flex-1 flex-col gap-2">
          <HelpLabel helpKey={helpKey('schedulingWeeksScheduleMode')}>{mode('name')}</HelpLabel>
          <Select
            value={props.weekModel.mode}
            onValueChange={v => props.onUpdateWeekModel({ ...props.weekModel, mode: v as ScheduleWeekMode })}
          >
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={ScheduleWeekMode.None}>{mode('none')}</SelectItem>
              <SelectItem value={ScheduleWeekMode.Repeat}>{mode('repeat')}</SelectItem>
              <SelectItem value={ScheduleWeekMode.Skip}>{mode('skip')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {props.weekModel.mode === ScheduleWeekMode.Skip && (
          <div className="flex flex-1 flex-col gap-2">
            <HelpLabel helpKey={helpKey('schedulingWeeksScheduleModeValue')}>{mode('value')}</HelpLabel>
            <Input
              type="number"
              value={props.weekModel.value}
              onChange={e => props.onUpdateWeekModel({ ...props.weekModel, value: Number(e.target.value) })}
            />
          </div>
        )}
      </div>
      <ScheduleDaysDefinitionEditor dayModel={props.dayModel} onUpdateDayModel={props.onUpdateDayModel} />
    </div>
  )
}
